import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { get } from '@/utils/storage' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
const tokenKey = process.env.VUE_APP_STORAGE_TOKEN // token
const userinfoKey = process.env.VUE_APP_STORAGE_USERINFO // userinfo

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/findpass', '/register'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  // if(to.query.state && to.query.code){
  //   router.push({ path: `/login?code=${to.query.code}&wxstate=${to.query.state}` })
  //   }
  NProgress.start()
  // 设置页面title
  document.title = getPageTitle(to.meta.title)
  // 在路由全局钩子beforeEach中，根据keepAlive属性，统一设置页面的缓存性
  if (to.meta.keepAlive) {
    store.commit('keepAlive/addkeepAlive', to.name)
  }
  // 确定用户是否已经登录
  const hasToken = get(tokenKey)
  const nodeAuth = store.getters['user/nodeAuth']
  if (hasToken) {
    if (nodeAuth.length) {
      if (to.path === '/login') {
        // 去登陆页面
        if (get('pass') === 'define') {
          // 如果已登录，则重定向到主页
          next({ path: '/home' })
        } else {
          next()
        }
        NProgress.done()
      } else {
        // 去其他页面
        const hasGetUserInfo = get(userinfoKey)
        if (hasGetUserInfo) {
          if (to.meta && to.meta.code) {
            if (!nodeAuth.includes(to.meta.code)) {
              next('/401')
            } else {
              next()
            }
          } else {
            next()
          }
        } else {
          // 这里最佳优化：可以再次请求一个用户信息接口 请求成功留在当前页，请求失败跳登录页
          await store.dispatch('user/resetToken') // 移除本地： token/userInfo/nodeAuth
          next(`/login`)
          NProgress.done()
        }
      }
    } else {
      if (to.path === '/login') {
        // 去登陆页面
        await store.dispatch('user/resetToken')
        next()
      } else {
        // 去其他页面
        await store.dispatch('user/resetToken')
        next('/login')
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单中，直接进入页面
      next()
    } else {
      // 其他没有访问权限的页面被重定向到登录页面。
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
